import type { Container } from "@egalregal/shared";

/** Cosine similarity of two equal-length vectors (normalized inputs stay in -1..1). */
export function cosine(a: ArrayLike<number>, b: ArrayLike<number>): number {
  const n = Math.min(a.length, b.length);
  let dot = 0;
  for (let i = 0; i < n; i++) dot += a[i]! * b[i]!;
  return dot;
}

/**
 * A ranked container hit. Reuses the server search contract (`SearchResult`
 * container kind) so the store and `SearchView` need no changes (ADR-0022, D2).
 */
export interface RankedContainer {
  container: Container;
  path: string;
  score: number;
}

/** Deterministic tiebreak: score desc, then name asc (ADR-0022, D1). */
export function sortRanked(a: RankedContainer, b: RankedContainer): number {
  if (b.score !== a.score) return b.score - a.score;
  return a.container.name.localeCompare(b.container.name);
}
